import { Pagination } from '../../../../../../models/Pagination';
import { cartConfig } from '../../../../../config';
import { http } from '../../../../../api/axios';
import { ProductSearchResponseOut } from '../../../../../store/api';

export const fetchCartCheckoutProducts = (params: Pagination): Promise<ProductSearchResponseOut> => {
    return http
        .post(
            cartConfig().endpointProducts,
            {},
            {
                params
            }
        )
        .then(response => response.data);
};
